import React from 'react';
import { Link } from 'react-router-dom';
import './FeaturedProducts.css';

const FeaturedProducts = () => {
  // Sample featured products
  const featuredProducts = [
    {
      id: 1,
      name: 'Eternal Legacy Necklace',
      category: 'Gold',
      price: '₹85,000',
      image: null,
      isNew: true
    },
    {
      id: 2,
      name: 'Promise Diamond Ring',
      category: 'Diamond',
      price: '₹1,25,000',
      image: null,
      isNew: true
    },
    {
      id: 3,
      name: 'Heritage Gold Bangles',
      category: 'Gold',
      price: '₹1,50,000',
      image: null,
      isNew: false
    }
  ];

  return (
    <section className="featured-section">
      <div className="container">
        <div className="section-header">
          <span className="section-subtitle">MIRAE</span>
          <h2 className="section-title">Featured <span className="gold-text">Collection</span></h2>
          <p className="section-description">Discover our most cherished pieces</p>
        </div>

        <div className="featured-grid">
          {featuredProducts.map((product) => (
            <div key={product.id} className="featured-card">
              <div className="product-image">
                {product.isNew && <span className="new-tag">New</span>}
                <div className="image-placeholder">
                  <span className="placeholder-icon">💎</span>
                </div>
              </div>
              <div className="product-info">
                <span className="product-category">{product.category}</span>
                <h3 className="product-name">{product.name}</h3>
                <p className="product-price">{product.price}</p>
                <button className="view-product-btn">View Product</button>
              </div>
            </div>
          ))}
        </div>

        <div className="view-all-container">
          <Link to="/shop" className="view-all-btn">
            View All Collection
            <span className="btn-arrow">→</span>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FeaturedProducts;